import { createFileRoute } from "@tanstack/react-router";

import { requireSuperAdmin } from "@/features/auth/permissions/requireSuperAdmin";
import { GuidelinePage } from "@/features/mbc-admin/guidelines/GuidelinePage";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute(
  "/_auth/_app-shell/admin/mbc/guidelines/new",
)({
  beforeLoad: ({ context }) => requireSuperAdmin(context),
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("New guideline");

  return <GuidelinePage guidelineId={null} />;
}
